import { Box, Container, Heading, Text } from '@chakra-ui/react'
import { useMutation } from '@tanstack/react-query'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { ApiError, FormsNewsletterService, FormsNewsletterVerify } from '../../../client'
import { useEffect, useState } from 'react'
import NotFound from '../../../components/Common/NotFound'

export const Route = createFileRoute('/_layout/newsletter/verifikation')({
    component: Verifikation,
    validateSearch: (search) => ({ action: search.action as string | undefined, token: search.token as string | undefined }),
    beforeLoad: ({ search }) => { if (!search.action) { throw redirect({ to: '/newsletter', }) } },
    notFoundComponent: NotFound,
})

function Verifikation() {
    const { action, token } = Route.useSearch()
    const [ verified, setVerified ] = useState<boolean>(false)
    const [ verifyError, setVerifyError ] = useState<string>()

    const mutationSubscribe = useMutation({
        mutationFn: (data: FormsNewsletterVerify) =>
            FormsNewsletterService.formsNewsletterVerify({ requestBody: data }),
        onSuccess: () => {
            setVerified(true)
        },
        onError: (err: ApiError) => {
            setVerified(false)
            setVerifyError((err.body as any)?.detail ?? "Etwas ist schiefgelaufen. Versuchen Sie es erneut oder kontaktieren Sie den Webseitenbetreiber")
        },
    })

    useEffect(() => {
        if(action == "subscribe" || action == "unsubscribe") mutationSubscribe.mutate({ token: token, action: action })
    }, [action, token])

    return (
        <Container>
            <Box textAlign="center">
                {verified ? (
                    <>
                        <Heading color="main">
                            {action === "subscribe" && "Verifiziert!"}
                            {action === "unsubscribe" && "Abgemeldet!"}
                        </Heading>

                        <Text>
                            {action === "subscribe" && "Vielen Dank, dass Sie sich für den wöchentlichen Newsletter der Wochen-Zeitung angemeldet haben."}
                            {action === "unsubscribe" && "Schade... Sie haben sich erfolgreich vom wöchentlichen Newsletter der Wochen-Zeitung abgemeldet."}
                        </Text>
                    </>
                ) : (
                    <>
                        <Heading color="main">Fehler!</Heading>
                        <Text>{verifyError}</Text>
                    </>
                )}
            </Box>
        </Container>
    )
}
